import { useLocation } from "react-router";

type Theme = "dark" | "light" | "system"

const useGetThemeMode = (): Theme | null => {
  try {
    const urlSearchParams = new URLSearchParams(useLocation().search);
    const returnUrlParam = urlSearchParams.get("ReturnUrl");

    if (!returnUrlParam) {
      return urlSearchParams.get("theme") as Theme | null;
    }

    const returnUrl = new URL(returnUrlParam);

    const returnUrlSearchParams = new URLSearchParams(returnUrl.search);

    const themeMode = returnUrlSearchParams.get("theme") as Theme | null;
    return themeMode;
  } catch (ex) {
    return "light";
  }
};

export const useGetParam = (param: string): string | null => {
  try {
    const urlSearchParams = new URLSearchParams(useLocation().search);
    const returnUrlParam = urlSearchParams.get("ReturnUrl");

    if (!returnUrlParam) {
      return urlSearchParams.get(param);
    }

    const returnUrl = new URL(returnUrlParam);

    const returnUrlSearchParams = new URLSearchParams(returnUrl.search);

    const paramValue = returnUrlSearchParams.get(param) as string | null;
    return paramValue;
  } catch (ex) {
    return "";
  }
};

export default useGetThemeMode;
